import { create } from 'zustand'

interface FirstLoadState {
  isFirstLoad: boolean
  setIsFirstLoad: (isFirstLoad: boolean) => void
}

export const useFirstLoadStore = create<FirstLoadState>((set) => ({
  isFirstLoad: true, // Default to true on app launch
  setIsFirstLoad: (isFirstLoad: boolean): void => set({ isFirstLoad })
}))
